// extracted by mini-css-extract-plugin
module.exports = {"root":"NiceTitle_root__u4Pwh","revert":"NiceTitle_revert__S9k3q"};